import React from 'react';
import { NavLink } from 'react-router-dom';

import Logout from '@common/react/components/UI/Logout/Logout';

import { pushEvent } from '@app/components/TagManager';
import { menuLoL } from '@app/components/UI/Header/MenuLoL';
import styles from '@app/components/UI/Header/MenuMobile/MenuMobile.module.scss';
import { CustomMenuItem } from '@app/objects/CustomMenuItem';
import { AppRoute } from '@app/utils/appRoutes';

export const menuMobile = (authorized: boolean): Array<CustomMenuItem> => {
	return [
		{
			path: AppRoute.USING_PHJ,
			name: 'Using Pet Hospice Journal',
		},
		{
			path: AppRoute.ABOUT,
			name: 'About the Journal',
		},
		{
			path: '#',
			name: 'Contact PHJ Support',
			modal: 'contact-form',
		},
		...(!authorized ? [
			{
				name: (
					<NavLink className="btn btn-primary" to={AppRoute.CREATE_PROFILE}>
						Begin
					</NavLink>
				),
			},
			{
				name: (
					<button className="btn btn-primary">
						Sign in
					</button>
				),
				modal: 'sign-in',
			},
		] : [
			{
				path: AppRoute.PETS,
				name: 'My Pets',
			},
			{
				path: AppRoute.PROFILE,
				name: 'Owner Profile',
			},
			{
				name: (
					<Logout
						clearState
						render={(logout) => (
							<a
								className={styles.logoutComponent}
								onClick={(e) => {
									logout(e);
								}}
							>
								Sign out
							</a>
						)}
					/>
				),
			},
		]),
		{
			name: (
				<>
					<span className={styles.horizontalLine} />
					<br />
					<span className={styles.textWrap}>
						For individual advice from a Lap of Love veterinarian on caring for your hospice pet…
					</span>
					<br />
					<a
						className="btn btn-purple-gray-border"
						href="https://www.lapoflove.com/online-booking"
						target="_blank"
						rel="noopener noreferrer"
						onClick={() => pushEvent('PHJ-MobileScheduleHeader')}
					>
						Schedule an Appointment
					</a>
					<br />
					<br />
					<a
						className="btn btn-purple-gray"
						href="https://www.lapoflove.com/find-a-vet"
						target="_blank"
						rel="noopener noreferrer"
					>
						Find a Vet
					</a>
				</>
			),
		},
		...menuLoL,
	];
};
